module.exports = __webpack_public_path__ + "background7.jpg?404799a48490cdd7dcef188f37642b88";